module.exports = __webpack_public_path__ + "img/banner3.c499a468.jpg";